<page-toolbar [pageActions]="pageActions" [subtitle]="subtitle" title="{{ 'pages.dynamic-content' | translate }}"></page-toolbar>

<page-content [noPadding]="true">
  <mat-card appearance="outlined" *ngIf="!isLoading && !dynamicContentEntrances?.length">
    <p>{{ 'general.no-data' | translate }}</p>
  </mat-card>
  <div *ngIf="!isLoading" class="container">
    <div class="dynamic-data">
      <div class="menu-buttons" *ngIf="dynamicContentEntrances?.length">
        <div class="menu-button" *ngFor="let entrance of dynamicContentEntrances; let i = index" (click)="openTab(i)"
             [ngClass]="{ 'active': tabIndex === i }" [id]="entrance._id">{{ entrance.title }}
          <mat-icon *ngIf="entrance.isSecured">group</mat-icon>
          <span *ngIf="getApp(entrance)?.remark" class="remark">{{getApp(entrance)?.remark}}</span>
        </div>
      </div>
      <div class="dynamic-data-content">
        <div class="table-container" *ngIf="dynamicContentEntrances[tabIndex]">
          <ng-container *ngIf="data?.live; else noLiveData">
            <mat-tab-group (selectedTabChange)="activeSubTab = activeSubTab === activeType ? 'category' : activeType">
              <mat-tab label="Live">
                <dynamic-content-table (content)="getContent()" [categories]="categoryData" [data]="data.live" [tabIndex]="tabIndex"
                                       [entrance]="dynamicContentEntrances[tabIndex]" [loading]="loading" [packageId]="packageIds"
                                       [archiveData]="data.archive" [app]="app" [showOrder]="showOrder"
                                       [globalEntries]="globalEntries"></dynamic-content-table>
              </mat-tab>
              <mat-tab label="Archiv">
                <dynamic-content-table (content)="getContent()" *ngIf="categoryData" [data]="data.archive" [liveData]="data.live"
                                       [loading]="loading" [archive]="true" [entrance]="dynamicContentEntrances[tabIndex]"
                                       [tabIndex]="tabIndex" [packageId]="packageIds" [app]="app"></dynamic-content-table>
              </mat-tab>
              <mat-tab [label]="'dynamicContent.categories' | translate" *ngIf="hasCategories(dynamicContentEntrances[tabIndex])">
                <dynamic-content-table (content)="getContent()" *ngIf="categoryData" [entrance]="dynamicContentEntrances[tabIndex]"
                                       [loading]="loading" [tabIndex]="tabIndex" type="category" [packageId]="packageIds"
                                       [data]="categoryData" [app]="app"></dynamic-content-table>
              </mat-tab>
            </mat-tab-group>
          </ng-container>
          <ng-template #noLiveData>
            <mat-tab-group *ngIf="hasCategories(dynamicContentEntrances[tabIndex]); else noCategory">
              <mat-tab label="{{ 'dynamicContent.categoryHeaders.' + dynamicContentEntrances[tabIndex].type | translate }}">
                <dynamic-content-table (content)="getContent()" [categories]="categoryData" [packageId]="packageIds" [loading]="loading"
                                       [entrance]="dynamicContentEntrances[tabIndex]" [tabIndex]="tabIndex" [data]="data" [app]="app"
                                       [showOrder]="showOrder" [globalEntries]="globalEntries">
                </dynamic-content-table>
              </mat-tab>
              <mat-tab [label]="'dynamicContent.categories' | translate">
                <dynamic-content-table (content)="getContent()" *ngIf="categoryData" [data]="categoryData" [loading]="loading"
                                       [entrance]="dynamicContentEntrances[tabIndex]" [tabIndex]="tabIndex" [packageId]="packageIds"
                                       type="category" [app]="app"></dynamic-content-table>
              </mat-tab>
            </mat-tab-group>
            <ng-template #noCategory>
              <dynamic-content-table (content)="getContent()" [data]="data" [entrance]="dynamicContentEntrances[tabIndex]"
                                     [showOrder]="showOrder" [loading]="loading" [tabIndex]="tabIndex" [packageId]="packageIds" [app]="app"
                                     [globalEntries]="globalEntries"></dynamic-content-table>
            </ng-template>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="loading" class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</page-content>
